// extracted by mini-css-extract-plugin
export default {"coursesProductsLayout":"CoursesProductsLayout_coursesProductsLayout__Qz2+J","coursesProductsContent":"CoursesProductsLayout_coursesProductsContent__pt8r1"};